// SVG imports:
import businessActivitySVG from "./svg/fp-business-activity.svg";
import classicReportsSVG from "./svg/fp-classic-reports.svg";
import companySVG from "./svg/fp-company.svg";
import compareSVG from "./svg/fp-compare.svg";
import emptyArchiveSVG from "./svg/empyArchiveLogo.svg";
import thinAngleDownSVG from "./svg/thin-arrow-down.svg";
import thinCircleTimesSVG from "./svg/thin-circle-times.svg";
import updateSVG from "./svg/fp-update.svg";
// JS imports:
import { elementSizeCssClass, medium } from "../size/index.js";
import classNames from "classnames";
import defineElementWithNoChild from "../helpers/defineElementWithNoChild.js";

/**
 * @typedef {Renderable} Icon
 *
 * Element rendering an icon.
 * This is a childless element.
 * @property {object} options -
 * @property {ElementSize} [options.iconSize] - Size of the icon
 */

const allIconsByClass = {};

export const angleLeftSolidIcon = makeIcon({
	cssClass: "fa-solid fa-angle-left",
});

export const angleRightSolidIcon = makeIcon({
	cssClass: "fa-solid fa-angle-right",
});

export const angleUpSolidIcon = makeIcon({
	cssClass: "fas fa-angle-up",
});

export const angleDownSolidIcon = makeIcon({
	cssClass: "fas fa-angle-down",
});

export const angleLeftIcon = makeIcon({
	cssClass: "fa fa-angle-left",
});

export const angleRightIcon = makeIcon({
	cssClass: "fa fa-angle-right",
});

export const bookmarkIcon = makeIcon({ cssClass: "fa fa-bookmark" });

export const bookmarkRegularIcon = makeIcon({ cssClass: "far fa-bookmark" });

export const buildingIcon = makeIcon({ cssClass: "fa fa-building" });

export const buildingSolidIcon = makeIcon({ cssClass: "fas fa-building" });

export const buildingRegularIcon = makeIcon({ cssClass: "far fa-building" });

export const calendarAltIcon = makeIcon({ cssClass: "fas fa-calendar-alt" });

export const calendarIcon = makeIcon({ cssClass: "far fa-calendar" });

export const calendarWeekIcon = makeIcon({ cssClass: "fa fa-calendar-week" });

export const caretDownIcon = makeIcon({ cssClass: "fa fa-caret-down" });

export const caretRightIcon = makeIcon({ cssClass: "fa fa-caret-right" });

export const chartLineIcon = makeIcon({ cssClass: "fa-solid fa-chart-line" });

export const checkIcon = makeIcon({ cssClass: "fa fa-check" });

export const checkDoubleIcon = makeIcon({ cssClass: "fa fa-check-double" });

export const chevronDownIcon = makeIcon({ cssClass: "fa fa-chevron-down" });

export const chevronUpIcon = makeIcon({ cssClass: "fa fa-chevron-up" });

export const circleCheckIcon = makeIcon({ cssClass: "fa fa-check-circle" });

export const circlePlusIcon = makeIcon({ cssClass: "fa fa-plus-circle" });

export const certificateIcon = makeIcon({ cssClass: "fa fa-certificate" });

export const circleIcon = makeIcon({ cssClass: "fa fa-circle" });

export const circleTimesIcon = makeIcon({ cssClass: "fa fa-times-circle" });

export const cloneIcon = makeIcon({ cssClass: "far fa-clone" });

export const columnsIcon = makeIcon({ cssClass: "fa fa-columns" });

export const cogIcon = makeIcon({ cssClass: "fas fa-cog" });

export const copyIcon = makeIcon({ cssClass: "far fa-copy" });

export const copySolidIcon = makeIcon({ cssClass: "fas fa-copy" });

export const databaseIcon = makeIcon({ cssClass: "fa fa-database" });

export const downloadIcon = makeIcon({ cssClass: "fa fa-download" });

export const editIcon = makeIcon({ cssClass: "fa fa-edit" });

export const editRegularIcon = makeIcon({ cssClass: "far fa-edit" });

export const envelopeIcon = makeIcon({ cssClass: "fa fa-envelope" });

export const snowflakeIcon = makeIcon({ cssClass: "fa-solid fa-snowflake" });

export const exclamationCircleIcon = makeIcon({
	cssClass: "fa fa-exclamation-circle",
});

export const exclamationTriangleIcon = makeIcon({
	cssClass: "fa fa-exclamation-triangle",
});

export const expandArrowsAltIcon = makeIcon({
	cssClass: "fas fa-expand-arrows-alt",
});

export const eyeIcon = makeIcon({ cssClass: "far fa-eye" });

export const eyeSlashIcon = makeIcon({ cssClass: "far fa-eye-slash" });

export const flagIcon = makeIcon({ cssClass: "fa fa-flag" });

export const flagRegularIcon = makeIcon({ cssClass: "fa-regular fa-flag" });

export const gripSolidIcon = makeIcon({ cssClass: "fas fa-grip" });

export const gripVerticalSolidIcon = makeIcon({
	cssClass: "fa-solid fa-grip-vertical",
});

export const homeIcon = makeIcon({ cssClass: "fa fa-home" });

export const homeSolidIcon = makeIcon({ cssClass: "fas fa-home" });

export const keyIcon = makeIcon({ cssClass: "fa fa-key" });

export const lightBulbIcon = makeIcon({ cssClass: "far fa-lightbulb" });

export const lockIcon = makeIcon({ cssClass: "fa fa-lock" });

export const magicIcon = makeIcon({ cssClass: "fa fa-magic" });

export const pencilIcon = makeIcon({ cssClass: "fa fa-pencil-alt" });

export const pencilSolidIcon = makeIcon({ cssClass: "fas fa-pencil-alt" });

export const penSolidIcon = makeIcon({ cssClass: "fas fa-pen" });

export const pictureIcon = makeIcon({ cssClass: "far fa-image" });

export const plusIcon = makeIcon({ cssClass: "fa fa-plus" });

export const infoCircleIcon = makeIcon({ cssClass: "fa fa-info-circle" });

export const fileAltIcon = makeIcon({ cssClass: "far fa-file-alt" });

export const filePdfIcon = makeIcon({ cssClass: "far fa-file-pdf" });

export const fileUploadIcon = makeIcon({ cssClass: "fas fa-file-upload" });

export const fireIcon = makeIcon({ cssClass: "fa-solid fa-fire-flame-curved" });

export const folderIcon = makeIcon({ cssClass: "fa fa-folder" });

export const circlePlusRegularIcon = makeIcon({
	cssClass: "far fa-circle-plus",
});

export const trashAltIcon = makeIcon({ cssClass: "far fa-trash-alt" });

export const maximizeIcon = makeIcon({ cssClass: "fas fa-arrows-alt" });

export const percentIcon = makeIcon({ cssClass: "fa-solid fa-percent" });

export const presentationIcon = makeIcon({
	cssClass: "fp-go-to-presentation-icon",
});

export const rocketIcon = makeIcon({ cssClass: "fa-solid fa-rocket" });

export const saveIcon = makeIcon({ cssClass: "far fa-save" });

export const sortNumericDownIcon = makeIcon({
	cssClass: "fas fa-sort-numeric-down",
});

export const sortIcon = makeIcon({ cssClass: "fa fa-sort" });

export const starIcon = makeIcon({ cssClass: "fa fa-star" });

export const syncIcon = makeIcon({ cssClass: "fas fa-sync" });

export const tableListIcon = makeIcon({ cssClass: "fa fa-th-list" });

export const thumbtack = makeIcon({ cssClass: "fa fa-thumbtack" });

export const timesIcon = makeIcon({ cssClass: "fa fa-times" });

export const timesSolidIcon = makeIcon({ cssClass: "fas fa-times" });

export const trashSolidAltIcon = makeIcon({ cssClass: "fas fa-trash-alt" });

export const undoIcon = makeIcon({ cssClass: "fa fa-undo" });

export const uploadIcon = makeIcon({ cssClass: "fa fa-upload" });

export const wrenchIcon = makeIcon({ cssClass: "fa fa-wrench" });

export const ellipsisIcon = makeIcon({ cssClass: "fas fa-ellipsis" });

export const xmarkIcon = makeIcon({ cssClass: "fas fa-xmark" });

export const classicReportIcon = makeSvgIcon({ content: classicReportsSVG });

export const updateIcon = makeSvgIcon({ content: updateSVG });

export const emptyArchiveIcon = makeSvgIcon({ content: emptyArchiveSVG });

export const businessActivityIcon = makeSvgIcon({
	content: businessActivitySVG,
});

export const companyIcon = makeSvgIcon({
	content: companySVG,
});

export const compareIcon = makeSvgIcon({
	content: compareSVG,
});

export const thinAngleDownIcon = makeSvgIcon({
	content: thinAngleDownSVG,
});

export const thinCircleTimesIcon = makeSvgIcon({
	content: thinCircleTimesSVG,
});

function makeSvgIcon({ content }) {
	return defineElementWithNoChild("icon", ({ size = medium }) => ({
		tag: ({ html, options: { class: cssClass, ...otherOptions } }) => {
			const node = html.svg(otherOptions);
			const svg = createSVGFromString(content);
			mergeTwoSVG({ receiver: node.element, otherSVG: svg });
			addAllClassesTo({ receiver: node.element, cssClass });

			return node;
		},
		options: { class: ["svg-icon", elementSizeCssClass("size", size)] },
	}));
}

/**
 * Retrieve an icon by its CSS class. If the icon does not exist, it will be
 * created.
 *
 * @param {string} cssClass - The CSS class of the icon
 * @return {Icon}
 */
export function getIconByCssClass(cssClass) {
	return allIconsByClass[cssClass] ?? makeIcon({ cssClass });
}

function makeIcon({ cssClass }) {
	const icon = defineElementWithNoChild("icon", ({ size = medium }) => ({
		tag: "i",
		options: { class: [cssClass, elementSizeCssClass("size", size)] },
	}));

	icon.getCssClass = () => cssClass;
	icon.getCssSelector = () => convertToCssSelector(cssClass);
	allIconsByClass[cssClass] = icon;

	return icon;
}

function convertToCssSelector(cssClass) {
	return `.${cssClass.replace(" ", ".")}`;
}

function createSVGFromString(content) {
	const container = document.createElement("div");
	container.innerHTML = content;
	return container.getElementsByTagName("svg")[0];
}

function mergeTwoSVG({ receiver, otherSVG }) {
	if (!otherSVG?.attributes) {
		return;
	}
	for (const attribute of [...otherSVG.attributes]) {
		receiver.setAttribute(attribute.name, attribute.value);
	}

	const children = [...otherSVG.childNodes];

	for (const child of children) {
		receiver.appendChild(child);
	}

	for (const cssClass of otherSVG.classList) {
		if (receiver.classList) {
			// receiver is a DOMElement
			receiver.classList.add(cssClass);
		} else {
			// receiver is a tagBrush
			receiver.addClass(cssClass);
		}
	}
}

function addAllClassesTo({ receiver, cssClass }) {
	const resolvedClasses = classNames(cssClass);
	for (const klass of resolvedClasses.split(" ")) {
		receiver.classList.add(klass);
	}
}
